import moment from 'moment'

/**
 * Converts a unix ms timestamp (e.g.: 1592897312030) to a time string in a long format with 2-digit hours
 * (e.g.: '09:12 AM'). This is mostly for locales that use AM/PM to add a leading zero upfront if hours are
 * less than 10. Conditional return with fallback 'Invalid date' to prevent uncontrolled auto-conversion of
 * arbitrary time formats.
 *
 * @param {number|string} timestamp - A unix ms timestamp.
 * @param {boolean} isTimeFormat12H - Result is 12H format with AM/PM.
 * @return {string} - A formatted time string.
 */

export function toLongTimeString(timestamp, isTimeFormat12H = false) {
    timestamp = Number.isInteger(timestamp) ? timestamp : parseInt(timestamp)

    const isValidTimestamp = /^[0-9]{13}$/g.test(timestamp)
    const isBool12H = typeof isTimeFormat12H === 'boolean'

    if (isTimeFormat12H && isBool12H && isValidTimestamp) {
        return moment(timestamp, 'x').format('hh:mm A')
    }

    if (!isTimeFormat12H && isBool12H && isValidTimestamp) {
        return moment(timestamp, 'x').format('HH:mm')
    }

    return 'Invalid date'
}
